import { render, staticRenderFns } from "./AdminNavbar.vue?vue&type=template&id=fa982700&scoped=true&"
import script from "./admin-navbar.ts?vue&type=script&lang=ts&"
export * from "./admin-navbar.ts?vue&type=script&lang=ts&"
import style0 from "./admin-navbar.scss?vue&type=style&index=0&id=fa982700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa982700",
  null
  
)

export default component.exports